import { Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import { catchError, map } from 'rxjs/operators';
import { Observable , of} from 'rxjs';
import { environment } from '../../../../environments/environment';
import { PostmethodService } from '../../../app-config/postmethod.service';

const GET_FILTER = gql`
  query {
    ZoneManager: getZMUserFilter{
      user_id
      username
      zone_id
      outlet_count
    }
    RegionManager: getRAUserFilter(filters: { role_id: 7 }) {
      user_id
      username
      region_id
      outlet_id
      zone_id
      state_id
    }
    AreaManager: getRAUserFilter(filters: { role_id: 8 }) {
        user_id
        username
        region_id
        outlet_id
        zone_id
        state_id
        parent_dealer_id
    }
  }
`;


@Injectable({
  providedIn: 'root',
})
export class FilterBarService {
  
  private readonly LOCAL_STORAGE_KEY = 'zrafilterData';
 
  constructor(
    private ws: PostmethodService,
    private apollo: Apollo
  ) {}

  getZRAFilterData(): Observable<any> {
    // 1️⃣ Check localStorage first
    const cached = localStorage.getItem(this.LOCAL_STORAGE_KEY);
    if (cached) {
      try {
        const parsed = JSON.parse(cached);
        return of(parsed)
      } catch (e) {
        console.warn('Failed to parse filterData from localStorage', e);
      }
    }

    // 2️⃣ If not cached, fetch from GraphQL
    return this.apollo
      .watchQuery({
        query: GET_FILTER,
        fetchPolicy: 'network-only', // always fetch from server if no cache
      })
      .valueChanges.pipe(
        map((result: any) => {
          const data = result.data;

          // 3️⃣ Save fetched data to localStorage
          localStorage.setItem(this.LOCAL_STORAGE_KEY, JSON.stringify(data));
          return data;
        })
      );
  }
  // Fetch users
//  getFilterData(hyperlocal: boolean): Observable<{
//   Geography: any[];
//   LeadSources: any[];
//   Product: any[];
//   Stage: any[];
// }> {
//   return this.apollo
//     .watchQuery<{
//       Geography?: any[];
//       LeadSources?: any[];
//       Product?: any[];
//       Stage?: any[];
//     }>({ query: GET_FILTER ,
//         variables: {
//           hyperlocal, // pass dynamic value
//         }
//     })
//     .valueChanges.pipe(
//       map((result) => ({
//         Geography: result.data?.Geography ?? [],
//         LeadSources: result.data?.LeadSources ?? [],
//         Product: result.data?.Product ?? [],
//         Stage: result.data?.Stage ?? [],
//       }))
//     );
// }

  // Add a user
//   addUser(name: string, email: string): Observable<any> {
//     return this.apollo.mutate({
//       mutation: ADD_USER,
//       variables: { name, email },
//     });
//   }

  getOutletsDatabyOutletID(): Observable<any[]> {
      const url = environment.loginUrl + "/dvr/get-outlets";
  
      return this.ws.wsPost({},url).pipe(
        map((response: any) => {
          const responseData = response?.body;
          if (responseData?.responseCode === 200 && responseData?.data?.length) {
            return responseData.data;
          }
  
          return []; // return empty array if no data or responseCode != 200
        }),
        catchError(err => {
          console.error('API error:', err);
          return of([]); // return empty array on error
        })
      );
  }

  getOutletsDatabyOutletIDdropdown(request:any): Observable<any[]> {
    console.log("request",request);
    const url = environment.loginUrl + "/dvr/get-outlets-dropdown";

    return this.ws.wsPost({outlet_id:request},url).pipe(
      map((response: any) => {
        const responseData = response?.body;
        console.log("responseData",responseData?.data)
        if (responseData?.responseCode === 200 && responseData?.data?.length) {
          return responseData.data;
        }

        return []; // return empty array if no data or responseCode != 200
      }),
      catchError(err => {
        console.error('API error:', err);
        return of([]); // return empty array on error
      })
    );
  }
}



